<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">

        <section slot="filters" class="gz-filters"></section>

        <section slot="above-content" class="flex flex-ai-c flex-sb">
            <section>
                <button 
                    class="gz-icon_cercle gz-icon_cercle_default gz-icon_cercle_accent"
                    title="очистить фильтры"
                    style="margin-right: 20px"
                    @click="filters = {status: '', actNumber: ''}"
                >
                    <span class="icon-cleaning-1"></span>
                </button>
            </section>
        </section>

        <section slot="content">
            <table class="gz-table">
                <thead class="gz-table__head">
                    <tr class="gz-table__filter-labels">
                        <td class="gz-table__filter-label"><span>Статус</span></td>
                        <td class="gz-table__filter-label"><span>Номер акта</span></td>
                        <td class="gz-table__filter-label">Дата создания</td>
                        <td class="gz-table__filter-label">Дата</td>
                        <td class="gz-table__filter-label">Адрес/помещение</td>
                        <td class="gz-table__filter-label">Добавил</td>
                        <td class="gz-table__filter-label">Верифицировал</td>
                    </tr>
                    <tr class="gz-table__filter">
                        <td>
                            <gz-select-container
                                type="filter"
                                class="gz-filter__item"
                                :dataList="checkupStatus"
                                :imported-data="filters.status"
                                @selectedItem="filters.status = $event">
                                <GZ-TextInput
                                    :importedData="filters.status.name"
                                    :readonly="true"
                                    :selectType="true"
                                    placeholder="Выберите статус"/>
                            </gz-select-container>
                        </td>
                        <td>
                            <GZ-TextInput 
                                @value="filters.actNumber = $event"
                                :importedData="filters.actNumber"
                                :placeholder="filters.actNumber ? filters.actNumber : 'Введите номер акта'"/>                            
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="(item, $index) in responseData" 
                        :key="$index"
                        class="gz-table__row">
                        <td><span>{{ findStatus(item) }}</span></td>
                        <td><span>{{ item.attributes.actnumber }}</span></td>
                        <td><span>{{ item.attributes.created | moment("DD.MM.YYYY") }}</span></td>
                        <td><span><b>{{ item.attributes.date | moment("DD.MM.YYYY") }}</b></span></td>
                        <td>
                            <AddressCard :obj-type="item.attributes.bid ? 
                                {type: 'bid', id: item.attributes.bid} : 
                                {type: 'pid', id: item.attributes.pid}"
                            />
                        </td>
                        <td><StaffInfo :uid="item.attributes.uid"/></td>
                        <td><StaffInfo :uid="item.attributes.verifiedByUid"/></td>
                    </tr>
                    <infinite-loading 
                        :identifier="infiniteId" 
                        @infinite="infiniteHandler"
                    ></infinite-loading>
                </tbody>
            </table>
        </section>  
    </gz-auth-view-template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AddressCard from '@/components/custom/admin/views/checkups/all-checkups/AddressCard'
import StaffInfo from '@/components/custom/admin/views/staff/BaseStaffInfoBlock'

export default {
    name: 'AdminCheckupsNew',

    components: {
        AddressCard,
        StaffInfo
    },
    data() {
        return {
            filters: {
                status: '',
                actNumber: '',
            },
            responseData: [],
            suggestionResult: [],

            //Pagination
            page: 0,
            infiniteId: +new Date(),
        }
    },
    computed: {
        ...mapGetters({
            checkups: 'checkups',
            checkupStatus: 'filterCheckupStatus',
        })
    },
    methods: {
        ...mapActions({
            getCheckups: 'getAllCheckups',
        }),

        async infiniteHandler($state) {
            try {
                await this.getCheckups({
                    pg: this.page,
                    actnumber: this.filters.actNumber,
                    status: this.filters.status.value,
                })
                
                if (this.checkups.length) {
                    this.page += 1
                    this.responseData.push(...this.checkups)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            } catch(e) {
                console.error(e)
            }

        },
        findStatus(item) {
            let s = ''
            this.checkupStatus.forEach(i => {
                if (i.value === item.attributes.status) s = i.name 
            })

            return s
        }
    },
    watch: {
        filters: {
            handler() {
                this.page = 0
                this.responseData = []
                this.infiniteId += 1
            },
            deep: true
        } 
    }
}
</script>